import { render, staticRenderFns } from "./ViewDistributorBalance.vue?vue&type=template&id=44aff59f&scoped=true&"
import script from "./ViewDistributorBalance.vue?vue&type=script&lang=js&"
export * from "./ViewDistributorBalance.vue?vue&type=script&lang=js&"
import style0 from "./ViewDistributorBalance.vue?vue&type=style&index=0&id=44aff59f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aff59f",
  null
  
)

export default component.exports